import { i18nMutations } from './i18n/mutations';
import * as types from './types';
import { isValidRedirectionRoute } from '../../services/authentication.service';
import { accountMutations } from './account/mutations';

import { state as defaultState } from './state';
import { dtGPTMutations } from './dtgpt/mutations';

export const mutations = {
  ...accountMutations,
  ...dtGPTMutations,

  [types.RESET_STATE](state) {
    Object.assign(state, defaultState);
  },

  [types.SET_NAV_DRAWER](state, value) {
    state.drawer = value;
  },
  [types.TOGGLE_SIDE_NAV](state, value) {
    state.drawer = !state.drawer;
  },
  [types.SET_MAIN_NAV_ACTIVE](state, value) {
    state.mainNavActive = value;
    // console.log("Log: state.mainNavActive", state.mainNavActive)
  },
  [types.SET_APP_NAV_ITEMS](state, value) {
    state.appNavItems = value;
  },

  // Login Mutations

  [types.SET_LOGIN_USER](state, payload) {
    state.loginUser = {
      ...state.loginUser,
      ...payload
    };
  },

  [types.SET_LOGIN_REDIRECT_ROUTE](state, payload) {
    // if (state.loginRedirectRoute.name === 'root') {
    // }
    if (isValidRedirectionRoute(payload.name)) {
      console.log('IS VALID REDIRECTION ROUTE', payload.name);
      state.loginRedirectRoute = payload;
    }
  },
  [types.SET_REQUEST_COUNT](state, payload) {
    console.log("SET_REQUEST_COUNT", payload)
    const { module, submodule, value } = payload;
    const moduleObj = state.appNavItems.find(e => e.route == module);
    const submoduleObj = moduleObj.children.find(e => e.route == submodule);
    console.log("MODULE OBJ", moduleObj)
    submoduleObj.badge = value;
  },

  ...i18nMutations
};



export const setMainNavInactive = (commit, flag) => {
  commit(types.SET_MAIN_NAV_ACTIVE, !flag, { root: true });
}
